import { useEffect, useState } from "react"
import AsideV2 from "../../../components/asidev2/AsideV2"
import { makeDashboard, getYesterdayDashboard, getDashboardByStartEnd } from "../../../hooks/firebase"
import "./Styles.css"
import HeaderV2 from "../../../components/adminV2/header/Header"
import { FiShoppingCart, FiDollarSign, FiActivity, FiUser } from "react-icons/fi";
import { MdOutlineAttachMoney } from "react-icons/md";


const HomeAdminV2 = () => {
    const [data, setData] = useState(false)
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    useEffect(() => {
        async function loadData() {
            console.log("teste")
            if (!data) {
                // Primeira vez que o componente carrega
                const yesterdayData = await getYesterdayDashboard();
                setData(yesterdayData);
            } else if (startDate && endDate) {
                // Quando as datas forem definidas
                console.log(startDate, endDate)
                const filteredData = await getDashboardByStartEnd(startDate, endDate);
                setData(filteredData);
            }
        }

        loadData();
    }, [startDate, endDate]);

    
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yyyy = yesterday.getFullYear();
    const mm = String(yesterday.getMonth() + 1).padStart(2, "0");
    const dd = String(yesterday.getDate()).padStart(2, "0");
    const yesterdayStr = `${yyyy}-${mm}-${dd}`;

    function getTotalUsersInState(stateData) {
        return Object.values(stateData).reduce((total, count) => total + count, 0);
    }
    

    return <div>
        <AsideV2 />
        {data && 
            <main className="main-wrapper">
            <HeaderV2 />
            <section className="section">
                <div className="container-fluid">
                
                <div className="title-wrapper pt-30">
                    <div className="row align-items-center">
                    <div className="col-md-6">
                        <div className="title">
                        <h2>Resumo Geral</h2>
                        </div>
                    </div>
                    
                    <div className="col-md-6">
                        <div className="breadcrumb-wrapper">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="#0">Dashboard</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Resumo Geral
                            </li>
                            </ol>
                        </nav>
                        </div>
                    </div>
                    
                    </div>
                    
                </div>

                <div className="row mb-20">
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                        <div className="d-flex gap-2 icon-card">
                            <div className="flex-fill">
                            <label htmlFor="startDate" className="form-label">Data Início:</label>
                            <input
                                type="date"
                                id="startDate"
                                className="form-control"
                                value={startDate}
                                max={yesterdayStr}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                            </div>

                            <div className="flex-fill">
                            <label htmlFor="endDate" className="form-label">Data Fim:</label>
                            <input
                                type="date"
                                id="endDate"
                                className="form-control"
                                value={endDate}
                                max={yesterdayStr}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                            </div>
                        </div>
                    </div>
                    
                </div>
                
                <div className="row">
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                        <div className="icon-card mb-30">
                        <div className="icon success">
                            <MdOutlineAttachMoney size={24} />
                        </div>
                        <div className="content">
                            <h6 className="mb-10">Faturamento</h6>
                            <h3 className="text-bold mb-10">
                            {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" })
                                .format((data.paids || 0) / 100)}
                            </h3>
                        </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                        <div className="icon-card mb-30">
                        <div className="icon purple">
                            <FiShoppingCart size={24} />
                        </div>
                        <div className="content">
                            <h6 className="mb-10">Novos Imóveis</h6>
                            <h3 className="text-bold mb-10">{data.newImoveis}</h3>
                        </div>
                        </div>
                    </div>                              

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                        <div className="icon-card mb-30">
                        <div className="icon primary">
                            <FiActivity size={24} />
                        </div>
                        <div className="content">
                            <h6 className="mb-10">Trafego</h6>
                            <h3 className="text-bold mb-10">{data.trafic}</h3>
                        </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-sm-6">
                        <div className="icon-card mb-30">
                        <div className="icon orange">
                            <FiUser size={24} />
                        </div>
                        <div className="content">
                            <h6 className="mb-10">Novos Usuários</h6>
                            <h3 className="text-bold mb-10">{data.newUsers}</h3>
                        </div>
                        </div>
                    </div>
                </div>

                
                
                <div className="row" style={{display: "none"}}>
                    <div className="col-lg-7">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between">
                        <div className="left">
                            <h6 className="text-medium mb-10">Receita</h6>
                            <h3 className="text-bold">$245,479</h3>
                        </div>
                        <div className="right">
                            <div className="select-style-1">
                            
                            </div>
                            
                        </div>
                        </div>
                        
                        <div className="chart">
                            <canvas id="Chart1" style={{ width: '100%', height: '400px', marginLeft: '-35px' }}></canvas>
                        </div>
                    </div>
                    </div>
                    
                    <div className="col-lg-5">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap align-items-center justify-content-between">
                        <div className="left">
                            <h6 className="text-medium mb-30">Trafego</h6>
                        </div>
                        <div className="right">
                            <div className="select-style-1">
                            
                            </div>
                            
                        </div>
                        </div>
                        
                        <div className="chart">
                        <canvas id="Chart2" style={{ width: '100%', height: '400px', marginLeft: '-35px' }}></canvas>
                        </div>
                    </div>
                    </div>
                    
                </div>
                
                <div className="row" >
                    <div className="col-lg-7">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Imóveis de Tendência</h6>
                        </div>
                        <div className="right">
                            <div className="select-style-1">
                            
                            </div>
                        </div>
                        </div>
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                        <thead>
                            <tr>
                            <th></th>
                            <th>
                                <h6 className="text-sm text-medium">Imagem</h6>
                            </th>
                            <th className="min-width">
                                <h6 className="text-sm text-medium">Categoria</h6>
                            </th>
                            <th className="min-width">
                                <h6 className="text-sm text-medium">Preço</h6>
                            </th>
                            <th className="min-width">
                                <h6 className="text-sm text-medium">Visualizações</h6>
                            </th>
                            <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && (
                            data.trendingProperties.map((property, index) => (
                                <tr key={index}>
                                <td>
                                    
                                </td>
                                <td>
                                    <div className="product">
                                    <div className="image">
                                        {property.image ? (
                                        <img
                                            src={property.image}
                                            alt={`Imagem do imóvel ${index + 1}`}
                                            style={{ width: 50, height: 50, objectFit: "cover" }}
                                        />
                                        ) : (
                                        <div
                                            style={{
                                            width: 50,
                                            height: 50,
                                            backgroundColor: "#ccc",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: 12,
                                            color: "#666",
                                            }}
                                        >
                                            Sem imagem
                                        </div>
                                        )}
                                    </div>
                                    </div>
                                </td>
                                <td>
                                    <p className="text-sm">{property.category}</p>
                                </td>
                                <td>
                                    <p className="text-sm">
                                    {property.price
                                        ? (property.price / 100).toLocaleString("pt-BR", {
                                            style: "currency",
                                            currency: "BRL",
                                        })
                                        : "—"}
                                    </p>
                                </td>
                                <td>
                                    <p className="text-sm">{property.views}</p>
                                </td>
                                <td>
                                    <div className="action justify-content-end">
                                    <button
                                        className="more-btn ml-10 dropdown-toggle"
                                        id={`moreAction${index}`}
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <i className="lni lni-more-alt"></i>
                                    </button>
                                    <ul
                                        className="dropdown-menu dropdown-menu-end"
                                        aria-labelledby={`moreAction${index}`}
                                    >
                                        <li className="dropdown-item">
                                        <a href="#0" className="text-gray">
                                            Remover
                                        </a>
                                        </li>
                                        <li className="dropdown-item">
                                        <a href="#0" className="text-gray">
                                            Editar
                                        </a>
                                        </li>
                                    </ul>
                                    </div>
                                </td>
                                </tr>
                            ))
                            )}
                        </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                    
                    <div className="col-lg-5">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Imóveis por usuário</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Tipo de Usuário</h6>
                                </th>
                                {/* <th className="min-width">
                                <h6 className="text-sm text-medium">Fatía</h6>
                                </th> */}
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Quantidade de Imóveis</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">CPF</p>
                                </div>
                                </td>
                                {/* <td>
                                <p className="text-sm">40%</p>
                                </td> */}
                                <td>
                                <p className="text-sm">{data.properties.byUser.CPF}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">CNPJ</p>
                                </div>
                                </td>
                                {/* <td>
                                <p className="text-sm">20%</p>
                                </td> */}
                                <td>
                                <p className="text-sm">{data.properties.byUser.CNPJ}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Imobiliária</p>
                                </div>
                                </td>
                                {/* <td>
                                <p className="text-sm">5%</p>
                                </td> */}
                                <td>
                                <p className="text-sm">{data.properties.byUser.Imobiliária}</p>
                                </td>
                            </tr>
                            
                            
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                    
                </div>

                <div className="row">
                    <div className="col-lg-4">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Tipos de Usuários</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Tipo de Usuário</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Quantidade</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">CPF</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.users.CPF}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">CNPJ</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.users.CNPJ}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Imobiliária</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.users.Imobiliária}</p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Acessos de rede social pelo site</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Rede Social</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Acessos</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Facebook</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.socialMidias.facebook}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Instagram</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.socialMidias.instagram}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Youtube</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.socialMidias.youtube}</p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Cliques para baixar o app</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Aplicativo</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Cliques</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Todos</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.clickToApp.android + data.clickToApp.ios}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Android</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.clickToApp.android}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">IOS</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.clickToApp.ios}</p>
                                </td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Situação anúncios grátis geral</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Status</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Quantidade</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Excluídos</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.properties.free.deleted}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Pausados</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.properties.free.pause}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Ativos</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.properties.free.active}</p>
                                </td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Situação anúncios turbinados geral</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Status</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Quantidade</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Excluídos</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.properties.highlight.deleted}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Pausados</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.properties.highlight.pause}</p>
                                </td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                <div className="product">
                                    <p className="text-sm">Ativos</p>
                                </div>
                                </td>
                                <td>
                                <p className="text-sm">{data.properties.highlight.active}</p>
                                </td>
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Usuários por Estado</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Estado</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Usuários</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                {Object.entries(data.usersByState).map(([state, types]) => {
                                    const total = getTotalUsersInState(types);

                                    return <tr><td></td><td><div className="product"><p className="text-sm">{state}</p></div></td><td><p className="text-sm">{total}</p></td></tr>
                                })}
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Imóveis por Estado</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Estado</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Imóveis</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                {Object.entries(data.properties.byState).map(([state, total]) => (
                                    <tr key={state}>
                                        <td></td>
                                        <td>
                                        <div className="product">
                                            <p className="text-sm">{state}</p>
                                        </div>
                                        </td>
                                        <td>
                                        <p className="text-sm">{total}</p>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-4">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Preferência do usuário por estado</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Estado</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Plataforma mais usada</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr><td></td><td><div className="product"><p className="text-sm">SP</p></div></td><td><p className="text-sm">Site</p></td></tr>
                                <tr><td></td><td><div className="product"><p className="text-sm">MG</p></div></td><td><p className="text-sm">Site</p></td></tr>
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Categorias mais buscadas</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Estado</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Categoria</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Buscas</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {data.categoryInsightsByState && Object.entries(data.categoryInsightsByState).map(([state, stats]) => {
                                return stats.mostSearchedCategories.map(({ category, count }, index) => (
                                <tr key={`${state}-${category}`}>
                                    <th></th>
                                    <td>
                                    <div className="product"><p className="text-sm">{state}</p></div>
                                    
                                    </td>
                                    <td><p className="text-sm">{category}</p></td>
                                    <td><p className="text-sm">{count}</p></td>
                                </tr>
                                ));
                            })}
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Tipos de usuário</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Estado</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Tipos</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Fatías</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                {data.usersByState && Object.entries(data.usersByState).map(([state, counts]) => (
                                    <tr key={state}>
                                    <td></td>
                                    <td>
                                        <div className="product">
                                        <p className="text-sm">{state}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="text-sm">CPF/CNPJ/Imobiliária</p>
                                    </td>
                                    <td>
                                        <p className="text-sm">
                                        {counts.CPF ?? 0}/{counts.CNPJ ?? 0}/{counts.Imobiliaria ?? 0}
                                        </p>
                                    </td>
                                    </tr>
                                ))}
                                </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Categoria de imóvel com mais visualizações</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Categoria</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Visualizações</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                {data.categoryInsightsByState && Object.entries(data.categoryInsightsByState).map(([state, stats]) => {
                                return stats.mostSearchedCategories.map(({ category, count }, index) => (
                                <tr key={`${state}-${category}`}>
                                    <th></th>
                                    <td>
                                    <div className="product"><p className="text-sm">{state}</p></div>
                                    
                                    </td>
                                    <td><p className="text-sm">{category}</p></td>
                                    <td><p className="text-sm">{count}</p></td>
                                </tr>
                                ));
                                })}
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="card-style mb-30">
                        <div className="title d-flex flex-wrap justify-content-between align-items-center">
                        <div className="left">
                            <h6 className="text-medium mb-30">Categoria de imóvel com mais denúncias</h6>
                        </div>
                        <div className="right">
                            
                        </div>
                        </div>
                        
                        <div className="table-responsive">
                        <table className="table top-selling-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th>
                                <h6 className="text-sm text-medium">Categoria</h6>
                                </th>
                                <th className="min-width">
                                <h6 className="text-sm text-medium">Denúncias</h6>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                               {data.categoryInsightsByState && Object.entries(data.categoryInsightsByState).map(([state, stats]) => {
                                const reported = stats.mostReportedCategory;
                                return (
                                    <tr key={`${state}-reported`}>
                                    <th></th>
                                    <td><div className="product"><p className="text-sm">{state}</p></div></td>
                                    <td><p className="text-sm">{reported.category}</p></td>
                                    <td><p className="text-sm">{reported.count}</p></td>
                                    </tr>
                                );
                                })}
                            </tbody>
                        </table>
                        
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                
            </section>
            </main>
        }
    </div>
}

export default HomeAdminV2